<app-notification-list></app-notification-list>

<router-outlet></router-outlet>
